import React, { Component } from 'react';
import { Link } from 'react-scroll';

export default class NavLink extends Component {

  componentDidMount() {
    window.addEventListener('resize', (e) => {
      this.forceUpdate();
    })
  }

  render() {
    let {to, title} = this.props;
    let offset = window.innerWidth >= 800 ? -80 : 0;
    return (
      <Link
        to={to}
        spy={true}
        smooth={true}
        hashSpy={false}
        offset={offset}
        duration={400}>
        {title}
      </Link>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/NavLink.js